import {makeAutoObservable} from "mobx";
import {IProductCaseAnswer} from "../rma-types";

class AnswerStore {
    private _model: IProductCaseAnswer = {} as IProductCaseAnswer;
    constructor(model: IProductCaseAnswer) {
        makeAutoObservable(this, {}, {autoBind: true});
        this._setModel(model);
    }
    private _setModel(model: IProductCaseAnswer){
        this._model = model;
    }
    
    public get answer(): string { return this._model.answer.length ? this._model.answer : this._model.translation; }
    public get id(): number { return this._model.id; }
}

export { AnswerStore as default };
